class Storage {
    constructor() {
        this.data = new Map();
    }
    flush() {
        this.data.clear();
    }
    set(name, data) {
        this.data.set(name, data);
    }
    get(name, defaultValue = null) {
        const value = this.data.get(name);

        return typeof value === 'undefined' ? defaultValue : value;
    }
    getAll() {
        return Object.fromEntries(this.data.entries());
    }
    patchObj(name, props) {
        const obj = {
            ...this.get(name, {}),
            ...props,
        };
        this.set(name, obj);
    }
    patchArr(name, items) {
        if (!Array.isArray(items)) {
            items = [items];
        }

        const arr = [...this.get(name, []), ...items];

        this.set(name, arr);
    }
}

export {Storage};
